<div class="position-fixed sticky-top w-100" style="left: 0; right: 0; z-index: 15000;">
  <app-alerting></app-alerting>
</div>
<div class="mx-auto">
  <div class="mx-1 py-3 px-4 d-flex justify-content-between gap-4">
    <app-filter [(ngModel)]="searchTerm"
                [minCharacters]="3" [searchFunction]="searchFunction" (resultsFound)="renderBunkerings($event)"
                placeholder="Search vessel, berth or product"
                class="search-field"></app-filter>
    <button type="button" class="btn btn-primary btn-plus" (click)="addBunkering();">
      <i class="button-icon fa-solid fa-light fa-plus"></i>
      <span class="ps-2 d-none d-md-inline">Add Bunkering</span>
    </button>
  </div>

  <hr class="m-0"/>
  <div class="row py-3 px-5">
    <div class="col-3 col-sm-4 col-md-2 ps-2 pe-0 pe-md-2">Vessel</div>
    <div class="d-none d-md-block col-md-2 ps-2 pe-0 pe-md-2">Berth</div>
    <div class="d-none d-md-block col-md-2 ps-2 pe-0 pe-md-2">Product(s)</div>
    <div class="col-3 col-md-2 ps-2 pe-0 pe-md-2">Start</div>
    <div class="col-3 col-md-2 ps-2 pe-0 pe-md-2">Completion</div>
    <div class="col-3 col-sm-2 px-2">Status</div>
  </div>

  <ng-container>
    <app-pagination #pagination [items]="bunkerings" class="accordion" id="bunkeringAccordeon">
      @for (bunkering of pagination.getItemsOnPage(); track bunkering) {
        <hr class="m-0"/>
        <div class="row regular-14-16 py-3 px-5">
          <div class="col-3 col-sm-4 col-md-2 ps-2 pe-0 pe-md-2" [ngClass]="{'cancelled': bunkering.cancelled}">
            <a class="text-decoration-none cursor-pointer text-center my-auto"
               (click)="editBunkering(bunkering)">{{ bunkering.vesselName }}</a>
          </div>
          <div class="d-none d-md-block col-md-2 ps-2 pe-0 pe-md-2"
               [ngClass]="{'cancelled': bunkering.cancelled}">{{ bunkering.berthName }}
          </div>
          <ul class="d-none d-md-block col-md-2 ps-2 pe-0 pe-md-2" [ngClass]="{'cancelled': bunkering.cancelled}"
              style="margin: 0">
            @for (item of bunkering.items; track item) {
              <li style="list-style-type: none;">
                {{ item.productType }} ({{ item.quantity }} {{ item.unitOfMeasure }})
              </li>
            }
          </ul>
          <ng-template #ResponsiveDate let-date="date">
            <span class="d-inline d-md-none">{{ formatDate(date, true) }}</span>
            <span class="d-none d-md-inline">{{ formatDate(date, false) }}</span>
          </ng-template>
          <div class="col-3 col-md-2 ps-2 pe-0 pe-md-2" [ngClass]="{'cancelled': bunkering.cancelled}">
            @if (bunkering.ets) {
              <span>
                <ng-container [ngTemplateOutlet]="ResponsiveDate"
                              [ngTemplateOutletContext]="{date: bunkering.ets}"></ng-container>
              </span>
            }
          </div>
          <div class="col-3 col-md-2 ps-2 pe-0 pe-md-2" [ngClass]="{'cancelled': bunkering.cancelled}">
            @if (bunkering.etc) {
              <span
              >
                {{ !bunkering.atc ? 'ETC:' : 'ATC:' }}
                <ng-container [ngTemplateOutlet]="ResponsiveDate"
                              [ngTemplateOutletContext]="{date: bunkering.atc || bunkering.etc}"></ng-container>
              </span>
            }
          </div>
          <div class="col-3 col-sm-2 px-2 position-relative">
            <div class="text-nowrap">
              <ng-template #PortAuthorityLabel>
                <span class="d-inline-block d-lg-none ps-1">PA</span>
                <span class="d-none d-lg-inline-block ps-1">port authority</span>
              </ng-template>
              @if ('DECLARED' == bunkering.harbourMasterDeclarationStatus?.status) {
                <i class="fa-light fa-circle-question declared"></i>
                <ng-container [ngTemplateOutlet]="PortAuthorityLabel"></ng-container>
              }
              @if ('ACCEPTED' == bunkering.harbourMasterDeclarationStatus?.status) {
                <i class="fa-light fa-circle-check accepted"></i>
                <ng-container [ngTemplateOutlet]="PortAuthorityLabel"></ng-container>
              }
              @if ('REJECTED' == bunkering.harbourMasterDeclarationStatus?.status) {
                <app-tooltip [placement]="'bottom'">
                  <i class="fa-light fa-circle-xmark rejected"></i>
                  <ng-container [ngTemplateOutlet]="PortAuthorityLabel"></ng-container>
                  <div class="tooltipContent">
                    <div class="text-start">
                      @if (bunkering.harbourMasterDeclarationStatus?.rejectionReason) {
                        <span>
                          {{ bunkering.harbourMasterDeclarationStatus.rejectionReason }}
                        </span>
                      }
                      @if (!bunkering.harbourMasterDeclarationStatus?.rejectionReason) {
                        <span>
                          No rejection reason given
                        </span>
                      }
                    </div>
                  </div>
                </app-tooltip>
              }
            </div>
            @if (bunkering.sendProToCustoms) {
              <div>
                <ng-template #CustomsLabel>
                  <span class="d-inline-block d-lg-none ps-1">Cus</span>
                  <span class="d-none d-lg-inline-block ps-1">customs</span>
                </ng-template>
                @if ('DECLARED' == bunkering.customsDeclarationStatus?.status) {
                  <i class="fa-light fa-circle-question declared"></i>
                  <ng-container [ngTemplateOutlet]="CustomsLabel"></ng-container>
                }
                @if ('ACCEPTED' == bunkering.customsDeclarationStatus?.status) {
                  <i class="fa-light fa-circle-check accepted"></i>
                  <ng-container [ngTemplateOutlet]="CustomsLabel"></ng-container>
                }
                @if ('REJECTED' == bunkering.customsDeclarationStatus?.status) {
                  <app-tooltip [placement]="'bottom'">
                    <i class="fa-light fa-circle-xmark rejected"></i>
                    <ng-container [ngTemplateOutlet]="CustomsLabel"></ng-container>
                    <div class="tooltipContent">
                      <div class="text-start">
                        @if (bunkering?.customsDeclarationStatus?.rejectionReason) {
                          <span>
                            {{ bunkering.customsDeclarationStatus.rejectionReason }}
                          </span>
                        }
                        @if (!bunkering?.customsDeclarationStatus?.rejectionReason) {
                          <span>
                            No rejection reason given
                          </span>
                        }
                      </div>
                    </div>
                  </app-tooltip>
                }
              </div>
            }
            <a
              class="btn btn-open-row rounded-circle text-decoration-none d-none d-md-flex align-items-center justify-content-center text-primary h1 mb-0"
              type="button" (click)="editBunkering(bunkering)">
              <i class="fa-light fa-angle-right"></i>
            </a>
          </div>
        </div>
      }
    </app-pagination>
  </ng-container>
  <hr class="m-0"/>
</div>
